import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Domains from "@/pages/home/components/Domains";
import HotRank from "@/pages/home/components/HotRank";
import Feed from "@/pages/home/components/Feed";
import Bloggers from "@/pages/home/components/Bloggers";
import Briefing from "@/pages/home/components/Briefing";
import Specials from "@/pages/home/components/Specials";
import Faq from "@/pages/home/components/Faq";
import About from "@/pages/home/components/About";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Domains />
        <HotRank />
        <Feed />
        <Bloggers />
        <Briefing />
        <Specials />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}